package tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet.model

import kotlinx.serialization.Serializable
import tta.destinigo.talktoastro.shared.data.ButtonStatus

@Serializable
data class ConsultationData(
    val isOnline: ButtonStatus,
    //val isOnline:Boolean,
    val queueNo:String,
    val waitTime:String,
    val isAvailable:Boolean
    //val isAvailable:Boolean
)


